module.exports = __webpack_public_path__ + "static/filter_applied-ee873ab185f92d1e678511600a231fb9.png";